export default __webpack_public_path__ + "static/media/NEXT_ICONA_P.18f5a15a.svg";